import createAction from './createAction';
import * as ReevooAPI from '../reevooRequests';

// because icepick is implemented using commonjs modules,
// which we don't suppport, it has to be required in this way
const icepick = require('icepick');

// 1. Initial state
const initialState = icepick.freeze({
  productReviews: null,
  conversations: null,
  organizationStatistics: null,
  organizationReviews: null
});

// 2. Actions
const FETCH_PRODUCT_REVIEWS = 'reevoo/FETCH_PRODUCT_REVIEWS';
const FETCH_PRODUCT_REVIEWS_STARTED = 'reevoo/FETCH_PRODUCT_REVIEWS_STARTED';
const FETCH_CONVERSATIONS = 'reevoo/FETCH_CONVERSATIONS';
const FETCH_ORGANIZATION_STATISTICS = 'reevoo/FETCH_ORGANIZATION_STATISTICS';
const FETCH_ORGANIZATION_REVIEWS = 'reevoo/FETCH_ORGANIZATION_REVIEWS';
const UP_VOTE_REVIEW = 'reevoo/UP_VOTE_REVIEW';
const DOWN_VOTE_REVIEW = 'reevoo/DOWN_VOTE_REVIEW';
const UP_VOTE_QUESTION = 'reevoo/UP_VOTE_QUESTION';
const DOWN_VOTE_QUESTION = 'reevoo/DOWN_VOTE_QUESTION';
const UP_VOTE_ANSWER = 'reevoo/UP_VOTE_ANSWER';
const DOWN_VOTE_ANSWER = 'reevoo/DOWN_VOTE_ANSWER';

// 3. Action creators
function getProductReviewsStarted() {
  return createAction(FETCH_PRODUCT_REVIEWS_STARTED);
}

function getProductReviewsSuccess(result) {
  return createAction(FETCH_PRODUCT_REVIEWS)(result);
}

export function getProductReviews(productId) {
  return (dispatch) => {
    dispatch(getProductReviewsStarted());
    return ReevooAPI.fetchProductReviews(productId)
      .then((response) => response.json())
      .then((result) => dispatch(getProductReviewsSuccess(result)));
    // .catch(error => dispatch(getProductsReviewFail(error)))
  };
}

function getConversationsSuccess(result) {
  return createAction(FETCH_CONVERSATIONS)(result);
}

export function getConversations(productId) {
  return (dispatch) => ReevooAPI.fetchConversations(productId)
    .then((response) => response.json())
    .then((result) => dispatch(getConversationsSuccess(result)));
}

function getOrganizationStatisticsSuccess(result) {
  return createAction(FETCH_ORGANIZATION_STATISTICS)(result);
}

export function getOrganizationStatistics() {
  return (dispatch) => ReevooAPI.fetchOrganizationStatistics()
    .then((response) => response.json())
    .then((result) => dispatch(getOrganizationStatisticsSuccess(result)));
}

function getOrganizationReviewsSuccess(result) {
  return createAction(FETCH_ORGANIZATION_REVIEWS)(result);
}

export function getOrganizationReviews() {
  return (dispatch) => ReevooAPI.fetchOrganizationReviews()
    .then((response) => response.json())
    .then((result) => dispatch(getOrganizationReviewsSuccess(result)));
}

function upVoteReviewSuccess(result) {
  return createAction(UP_VOTE_REVIEW)(result);
}

export function upVoteReview(reviewId) {
  return (dispatch) => ReevooAPI.upVoteReview(reviewId)
    .then((response) => response.json())
    .then((result) => dispatch(upVoteReviewSuccess(result)));
}

function downVoteReviewSuccess(reviewId) {
  return createAction(DOWN_VOTE_REVIEW)(reviewId);
}

export function downVoteReview(reviewId) {
  return (dispatch) => ReevooAPI.downVoteReview(reviewId)
    .then((response) => response.json())
    .then((result) => dispatch(downVoteReviewSuccess(result)));
}

function upVoteQuestionSuccess(result) {
  return createAction(UP_VOTE_QUESTION)(result);
}

export function upVoteQuestion(questionId) {
  return (dispatch) => ReevooAPI.upVoteQuestion(questionId)
    .then((response) => response.json())
    .then((result) => dispatch(upVoteQuestionSuccess(result)));
}

function downVoteQuestionSuccess(result) {
  return createAction(DOWN_VOTE_QUESTION)(result);
}

export function downVoteQuestion(questionId) {
  return (dispatch) => ReevooAPI.downVoteQuestion(questionId)
    .then((response) => response.json())
    .then((result) => dispatch(downVoteQuestionSuccess(result)));
}

function upVoteAnswerSuccess(result) {
  return createAction(UP_VOTE_ANSWER)(result);
}

export function upVoteAnswer(answerId) {
  return (dispatch) => ReevooAPI.upVoteAnswer(answerId)
    .then((response) => response.json())
    .then((result) => dispatch(upVoteAnswerSuccess(result)));
}

function downVoteAnswerSuccess(answerId) {
  return createAction(DOWN_VOTE_ANSWER)(answerId);
}

export function downVoteAnswer(answerId) {
  return (dispatch) => ReevooAPI.downVoteAnswer(answerId)
    .then((response) => response.json())
    .then((result) => dispatch(downVoteAnswerSuccess(result)));
}

// 4. Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_PRODUCT_REVIEWS:
      return icepick.setIn(state, ['productReviews'], action.payload);
    case FETCH_CONVERSATIONS:
      return icepick.setIn(state, ['conversations'], action.payload);
    case FETCH_ORGANIZATION_STATISTICS:
      return icepick.setIn(state, ['organizationStatistics'], action.payload);
    case FETCH_ORGANIZATION_REVIEWS:
      return icepick.setIn(state, ['organizationReviews'], action.payload);
    default:
      return state;
  }
}
